import { useState } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';
import Input from '../../components/Input';

export default function EmployeeScheduleImport() {
  const [csvText, setCsvText] = useState('');
  const [importResult, setImportResult] = useState<any>(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  const downloadTemplate = async () => {
    const res = await api.get('/tms/employee-schedules/template', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'employee_schedule_template.xlsx';
    a.click();
  };

  const exportMonth = async () => {
    const res = await api.get('/tms/employee-schedules/export', { params: { month }, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `employee_schedule_${month}.xlsx`;
    a.click();
  };

  const handleImport = async () => {
    const lines = csvText.trim().split('\n').filter(Boolean);
    if (lines.length < 2) {
      alert('Paste rows with a header row: date,employeeCode,shiftOrReasonCode (date as DD/MM/YYYY)');
      return;
    }
    const rows = lines.slice(1).map((line) => {
      const [date, employeeCode, shiftOrReasonCode] = line.split(',').map((s) => s.trim());
      return { date, employeeCode, shiftOrReasonCode };
    });
    const res = await api.post('/tms/employee-schedules/import', { rows });
    setImportResult(res.data.results);
  };

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Employee Schedule — Excel Import/Export</h1>

      <div className="bg-white rounded-lg shadow p-6 space-y-3">
        <h2 className="font-semibold">1. Download Template</h2>
        <Button variant="secondary" onClick={downloadTemplate}>Download .xlsx Template</Button>
      </div>

      <div className="bg-white rounded-lg shadow p-6 space-y-3">
        <h2 className="font-semibold">2. Import</h2>
        <p className="text-sm text-gray-600">
          Open the downloaded template in Excel, fill it in, then paste the rows here (header row required):{' '}
          <code className="bg-gray-100 px-1">date,employeeCode,shiftOrReasonCode</code> — date as DD/MM/YYYY.
        </p>
        <textarea
          value={csvText}
          onChange={(e) => setCsvText(e.target.value)}
          rows={8}
          className="w-full border rounded-lg p-3 font-mono text-xs"
          placeholder={'date,employeeCode,shiftOrReasonCode\n01/06/2026,EMP001,MORNING'}
        />
        <Button onClick={handleImport}>Import</Button>
        {importResult && (
          <div className="bg-gray-50 rounded-lg p-3 text-xs max-h-48 overflow-y-auto">
            <pre>{JSON.stringify(importResult, null, 2)}</pre>
          </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow p-6 space-y-3">
        <h2 className="font-semibold">3. Export a month's schedule</h2>
        <div className="flex gap-3 items-end">
          <Input label="Month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} />
          <Button variant="secondary" onClick={exportMonth}>Export .xlsx</Button>
        </div>
      </div>
    </div>
  );
}
